import { render } from "./RFITable.vue?vue&type=template&id=211baefe"
import script from "./RFITable.vue?vue&type=script&lang=js"
export * from "./RFITable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__